export default __webpack_public_path__ + "static/2_34-93a016909df946106f86d7e6d9b24293.png";